module.exports = __webpack_public_path__ + "img/like4ing.00bbd0ed.gif";